import { EmployerClassification } from 'src/graphql/types/verificationOfEmployments'

/**
 * Human-readable reason shown in the "Not a DOT Employer" badge tooltip.
 * Mirrors the categories audited/classified server-side — see ENG-4562.
 */
export const EMPLOYER_CLASSIFICATION_LABELS: Record<
  EmployerClassification,
  string
> = {
  [EmployerClassification.NON_CARRIER_UNKNOWN]: 'Unknown / blank employer',
  [EmployerClassification.SELF_EMPLOYED]: 'Self-employed / owner-operator',
  [EmployerClassification.EMPLOYMENT_GAP]: 'Employment gap',
  [EmployerClassification.MILITARY_SERVICE]: 'Military service',
  [EmployerClassification.GIG]: 'Gig / rideshare work',
}

export function getEmployerClassificationLabel(
  classification: EmployerClassification | null | undefined
): string | null {
  if (!classification) return null
  return EMPLOYER_CLASSIFICATION_LABELS[classification] ?? null
}
